import React from "react";

type RenderEmptySubcontentPropType = {
    emptySubcontent: string;
    linkText: string;
}

export default function RenderEmptySubcontent (props: RenderEmptySubcontentPropType) {
  const { emptySubcontent, linkText } = props;
  const mentioningGuideUrl = "https://www.willow.co/customer-success-and-support/how-to-tag-people-and-businesses-on-linkedin?ref=willow_app"

  const idx = emptySubcontent.indexOf(linkText);

  // fallback: if the pattern doesn't match, just render the raw string
  if (idx === -1) {
    return (
      <div className="subcontent">
        {emptySubcontent}
      </div>
    );
  }

  const before = emptySubcontent.slice(0, idx);
  const after = emptySubcontent.slice(idx + linkText.length);

  return (
    <div className="subcontent">
      {before}
      <a
        href={mentioningGuideUrl}
        target="_blank"
        rel="noreferrer"
      >
        {linkText}
      </a>
      {after}
    </div>
  );
};
